/* eslint-disable react/prop-types */
import React, { useRef, useEffect } from 'react';
import { Editor } from '@tinymce/tinymce-react';

import CircularProgress from '@mui/material/CircularProgress';

import MDBox from 'components/MDBox';

import './style.css';

export default function App({ initialContent="", realTimeContent=()=>{}, height, ref }) {
  const editorRef = useRef(null);

  return (
    <MDBox sx={{ position: 'relative' }}>
        <MDBox sx={{ position: 'absolute', zIndex: 0, textAlign: 'center', width: '100%' }}>
            <CircularProgress color="inherit" sx={{ textAlign: 'center' }} />
        </MDBox>
        <MDBox sx={{ position: 'relative', zIndex: 1 }}>
            <Editor
                ref={ref}
                apiKey={process.env.REACT_APP_TINYMCE_API_KEY}
                onInit={(evt, editor) => editorRef.current = editor}
                initialValue={initialContent}
                init={{
                    height: height ? height : 500,
                    menubar: false,
                    plugins: [
                        'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                        'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                        'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                    ],
                    toolbar: 'undo redo | blocks | ' +
                        'bold italic forecolor | alignleft aligncenter ' +
                        'alignright alignjustify | bullist numlist outdent indent | ' +
                        'removeformat | help',
                    content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                }}
                onEditorChange={realTimeContent}
            />
        </MDBox>
    </MDBox>
    
  );
}